<template>
    <CModal
      :color="color"
      :show.sync="showModal"
      size="lg"
      class="basic-modal-color"
    >   
    <template #header>
      <CRow style="width: 100%; height: 35px;">
        <CCol md="9">
          <h5 class="modal-title">{{title}}</h5>
        </CCol>
        <CCol md="3">
          
        </CCol>
      </CRow>
      <CButtonClose @click="showModal = false"/>            
    </template>
      <CRow>      
        <CCol md="12">
          <span v-if="!event || event.image == ''"><CBadge color="danger" style="width: 100%;text-wrap: wrap; padding: 5px;">El evento no tiene una imagen de invitación cargada<br/>{{ modeWarningText }}</CBadge><br/><br/></span>        
          <CRow class="mb-3">
            <CCol md="4" sm="12" class="d-flex align-items-center mb-2 mb-md-0">
              <CButton class="crema" size="sm" :disabled="isSearching" @click="selectAll()">Seleccionar Todos</CButton>
            </CCol>
            <CCol md="8" sm="12" class="d-flex align-items-center">
              <input
                v-model="searchTerm"
                type="text"
                class="form-control"
                placeholder="Buscar invitado..."
              />
            </CCol>
          </CRow>
          <CDataTable
            :hover="hover"
            :striped="striped"
            :border="border"
            :small="small"
            :fixed="fixed"
            :items="filteredGuests"
            :fields="fields"
            :dark="dark"
            :noItemsView="{ noResults: 'No se encontraron elementos', noItems: 'Sin Invitados' }"
          >         
            <template #position="{item}">
              <td class="text-center w80">
                <input
                  type="checkbox"
                  v-model="idsGuests"
                  @change="checkGuests(item)"
                  :value="item.id"
                  :id="'check-'+item.id"
                  :disabled="isInCooldown(item) || isInvitationSelectionBlocked(item)"
                >
              </td>
            </template>
            <template #name="{item}"><td class="text-left" style="font-size: 12px;"><b style="font-size: 12px;">{{item.name}}</b></td></template>
            <template #last_name="{item}"><td class="text-left" style="font-size: 12px;"><b style="font-size: 12px;">{{item.last_name}}</b></td></template>
            <template #nickname="{item}"><td class="text-center w150" style="font-size: 12px;">{{item.nickname}}</td></template>
            <template #phone="{item}">
              <td class="text-center w100" style="font-size: 12px;">
                {{item.phone}}
                <div v-if="Number(item.is_in_cooldown) === 1 && item.whatsapp_cooldown_until" style="font-size: 11px;">
                  <CBadge color="warning">Cooldown</CBadge>
                  hasta {{ item.whatsapp_cooldown_until | datetime }}
                </div>
              </td>
            </template>
            <template #email="{item}">
              <td class="text-center w200" style="font-size: 12px;">
                <template v-if="item.email != ''">
                  {{item.email}}
                </template>
                <template v-else>
                  -
                </template>                  
              </td>
            </template>
            <template #tickets="{item}">
              <td class="text-center w100" style="font-size: 12px;">
                {{item.tickets}}
                <div v-if="isInvitationSelectionBlocked(item)" style="font-size: 11px;">
                  <CBadge color="warning">No elegible para invitación</CBadge>
                </div>
              </td>
            </template>
            <template #table="{item}">
              <td class="text-center w100" style="font-size: 12px;">
                <template v-if="item.table != ''">
                  {{item.table}}
                </template>
                <template v-else>
                  -
                </template>                
              </td>
            </template>
            <template #confirm_date="{item}">
              <td class="text-center w100">
                <template v-if="item.is_confirm != ''">
                  {{item.confirm_date | date}}                  
                </template>                
              </td>
            </template>       
            <template #confirm_method="{item}">
              <td class="text-center w100" style="font-size: 16px;">
                <template v-if="item.confirm_method == 'admin'">
                  Administrador
                </template>
                <template v-else-if="item.confirm_method == 'whats'">
                  Whatsapp
                </template>
                <template v-else-if="item.confirm_method == 'email'">
                  Correo Electronico
                </template>
                <template v-else>
                  -
                </template>
              </td>
            </template>                 
            <template #is_confirm="{item}">
              <td class="text-center w100" style="font-size: 16px;">
                <template v-if="item.is_confirm == 0">
                  <CBadge color="warning">Pendiente</CBadge>
                </template>
                <template v-else-if="item.is_confirm == 3">
                  <CBadge color="warning">Incompleta</CBadge>
                </template>
                <template v-else-if="item.is_confirm == 2">
                  <CBadge color="danger">No</CBadge>
                </template>
                <template v-else>
                  <CBadge color="success">Si</CBadge>
                </template>          
              </td>
            </template>
            <template #actions="{item}">
              <td style="padding: 0px; padding-bottom: 2px;" class="table_actions w150 text-center">                
              </td>
            </template>
          </CDataTable>        
        </CCol>              
      </CRow>      
        <template #footer>
          <CButton @click="closeModal" color="secondary">Cancelar</CButton>
          <CButton @click="sendInvitation" :color="color">Enviar {{ modeButtonLabel }}</CButton>
        </template>
    </CModal>
</template>

<script>
import store from '@/store';
import ws from '@/services/events_guests';

export default {
  name: 'SendMasiveInvitationModal',
  props: {
    fields: {
      type: Array,
      default () {
        return [
          {key: 'position', label: 'N°' ,_style:"font-size: 12px;"},
          {key: 'name', label: 'Nombre',_style:"font-size: 12px;"},
          {key: 'last_name', label: 'Apellido',_style:"font-size: 12px;"},
          {key: 'nickname', label: 'Apodo',_style:"font-size: 12px;"},
          {key: 'phone', label: 'Whatsapp',_style:"font-size: 12px;"},
          {key: 'email', label: 'Email',_style:"font-size: 12px;"},
          {key: 'tickets', label: 'Invitados',_style:"font-size: 12px;"},
          {key: 'table', label: 'Mesa',_style:"font-size: 12px;"},
          {key: 'is_confirm', label: 'Confirmación',_style:"font-size: 12px;"},
        ]
      }
    },
    caption: {
      type: String,
      default: 'Table'
    },
    hover: Boolean,
    striped: Boolean,
    border: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean
  },
  components: {
  },
  data () {
    return {
      showModal: false,
      title: "Enviar Invitación",
      color: "info",
      submitted: false,      
      guests: [],      
      idsGuests:[],
      statusCheckAll: false,
      event: false,
      searchTerm: "",
      mode: 'reminder'
    }
  },
  mounted: async function() {    
    
  },
  computed: {
    isSearching () {
      return this.searchTerm.trim().length > 0;
    },
    filteredGuests () {
      if (!this.isSearching) {
        return this.guests;
      }

      const term = this.searchTerm.trim().toLowerCase();

      return this.guests.filter(guest => {
        const searchableValues = [
          guest.name,
          guest.last_name,
          guest.nickname,
          guest.phone,
          guest.email,
          guest.table,
          guest.tickets,
        ]
          .map(value => (value === null || value === undefined ? '' : String(value).toLowerCase()))
          .join(' ');

        return searchableValues.includes(term);
      });
    },
    modeButtonLabel () {
      return this.mode === 'invitation' ? 'Invitación' : 'Recordatorio';
    },
    modeWarningText () {
      return this.mode === 'invitation'
        ? 'la invitación será enviada con una imagen con el logo de Confirma.me'
        : 'el recordatorio será enviado con una imagen con el logo de Confirma.me';
    },
  },
  methods: {
    isInCooldown (guest) {
      if (!guest) return false;
      return Number(guest.is_in_cooldown) === 1 && !!guest.whatsapp_cooldown_until;
    },

    canSendReminder (guest) {
      if (!guest) return false;

      const isIncomplete = Number(guest.is_confirm) === 3;
      const hasEvidence = Number(guest.has_invitation_evidence) === 1;
      return isIncomplete && hasEvidence && !this.isInCooldown(guest);
    },

    canSendInvitation (guest) {
      if (!guest) return false;

      const isCandidate = [0, 3].includes(Number(guest.is_confirm));
      return isCandidate && !this.isInCooldown(guest);
    },

    isInvitationRestrictedByTickets (guest) {
      if (!guest) return false;

      const tickets = Number(guest.tickets);
      return !Number.isNaN(tickets) && tickets > 10;
    },

    isInvitationSelectionBlocked (guest) {
      return this.mode === 'invitation' && this.isInvitationRestrictedByTickets(guest);
    },

    async showSendModal (event_id, event, mode = 'reminder') {
      this.event = event;
      this.searchTerm = "";
      this.mode = mode;

      this.loading();
        this.showModal = true;
        this.color = "info";
        this.title = this.mode === 'invitation' ? 'Enviar Invitación' : 'Enviar Recordatorio';
        this.isEdit = false;
        this.submitted = false;

        this.guests = [];
        this.idsGuests = [];
        this.statusCheckAll = false;

        let filters = {
          event_id: event_id,
        };
      
        let response = await ws.get(filters);
        if(response.type == "success"){
          this.guests = (response.data || []).filter(guest => this.mode === 'invitation' ? this.canSendInvitation(guest) : this.canSendReminder(guest));

          this.guests.forEach(function callback(guest) {
              guest.checkbox = false;
          });
        }
      this.loaded();

    },
    async sendInvitation () {
      this.loading();

      let invitations = this.idsGuests;

      if(invitations.length > 0){
        let response = this.mode === 'invitation'
          ? await ws.sendMasiveInvitation({data: invitations})
          : await ws.sendMasiveReminder({data: invitations});

        this.closeModal();
        
        if(response.type == "success"){
          this.showToast("success", response.message || "Las notificaciones para los invitados han sido enviadas correctamente.");
        }
        else{
          this.showToast("error", response.message);
        }
        
      }
      else{
        this.showToast("error", "Debes seleccionar al menos un invitado para enviar las notificaciones.");
      }

      this.loaded();          
    },
    checkGuests: function(element){
      if (!this.idsGuests.includes(element.id)) {
        this.statusCheckAll = false;
      }
    },
    selectAll () {
      if (this.isSearching) {
        return;
      }

      if(!this.idsGuests.length > 0){
        this.statusCheckAll = false;  
      }
      this.idsGuests = [];            
      this.statusCheckAll = !this.statusCheckAll
      if(this.statusCheckAll){
        this.guests.forEach(element => {
          if (this.isInCooldown(element) || this.isInvitationSelectionBlocked(element)) {
            return;
          }
          this.idsGuests.push(element.id) ;
        });
      }
    },
    closeModal () {
      this.showModal = false;
      this.searchTerm = "";

      this.guests.forEach(function callback(guest) {
          guest.checkbox = false;
      });

      this.submitted = false
    },
    showToast(type, message){
      store.commit('toast', {color: type, message: message});
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  },
}
</script>
<style>
.basic-modal-color .modal-header{
  background-color: #668269 !important;
}
.crema{
  background-color: #F4F0E5;
  color: black;
}
</style>